import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Session } from '@custom-types/Session';

import { RootState } from './store';

interface State {
  info?: Session;
}

export const initialState: State = {
  info: undefined,
};

const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionInfo: (state: State, action: PayloadAction<Session>) => {
      // eslint-disable-next-line no-param-reassign
      state.info = action.payload;
    },
    clearSessionInfo: (state: State) => {
      // eslint-disable-next-line no-param-reassign
      state.info = undefined;
    },
  },
});

export default sessionSlice;

export const getSessionInfo = (state: RootState) => state[sessionSlice.name].info;

export const {
  actions: { setSessionInfo, clearSessionInfo },
  reducer: sessionReducer,
} = sessionSlice;
